export const arrowLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M15.032 7.04H3.625a.167.167 0 0 1-.11-.291l5.758-5.067A.96.96 0 0 0 8.006.24L.552 6.8a1.6 1.6 0 0 0 0 2.4l7.453 6.558a.96.96 0 0 0 1.266-1.44L3.513 9.25a.167.167 0 0 1 .11-.292h11.409a.96.96 0 0 0 0-1.92z"/></svg>`,
    name: 'arrow-left'
};